export enum SUPPORTED_PSP_MODE {
  PAYOUT = 'PAYOUT',
  ISSUING = 'ISSUING',
}

export type SupportedPspMode =
  (typeof SUPPORTED_PSP_MODE)[keyof typeof SUPPORTED_PSP_MODE];
